export enum EaButtonType {
    PRIMARY = 'primary'
}

export enum EaSortingDirection {
    ASC = 'asc',
    DESC = 'desc'
}
